import { Box, Stack } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { DataGridPro } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { useMemo } from "react";
import type { ISO8601 } from "../../../../../utils/iso8601";
import { AnalyticsDatetime } from "../../../utils/analytics-datetime";
import { ExportToolbar } from "../../generic/export-toolbar";
import type { InteractionsByUrl } from "./types";

export const NestedLinkTable: FC<{ row: InteractionsByUrl }> = ({ row }) => {
  const columns = useMemo(() => {
    return [
      {
        field: "first_name",
        headerName: "First Name",
        flex: 1,
      },
      {
        field: "last_name",
        headerName: "Last Name",
        flex: 1,
      },
      {
        field: "clicks",
        headerName: "Clicks",
        flex: 0.5,
      },
      {
        field: "first_interaction",
        headerName: "First Interaction",
        flex: 2,
        renderCell: (params: GridRenderCellParams<{ first_interaction: ISO8601 }, ISO8601>) =>
          params.value ? (
            <Stack direction="row" spacing={1} alignItems="center" height="100%">
              <AnalyticsDatetime datetime={params.value} />
            </Stack>
          ) : null,
      },
      {
        field: "last_interaction",
        headerName: "Last Interaction",
        flex: 2,
        renderCell: (params: GridRenderCellParams<{ last_interaction: ISO8601 }, ISO8601>) =>
          params.value ? (
            <Stack direction="row" spacing={1} alignItems="center" height="100%">
              <AnalyticsDatetime datetime={params.value} />
            </Stack>
          ) : null,
      },
      {
        field: "work_email",
        headerName: "Work Email",
        flex: 1,
      },
      {
        field: "delivery_address",
        headerName: "Delivery Address",
        flex: 1,
      },
    ];
  }, []);

  return (
    <Box sx={{ ml: "50px" }}>
      <DataGridPro
        hideFooterRowCount
        rows={Object.values(row.people).map(
          (
            {
              first_name,
              last_name,
              clicks,
              first_interaction,
              last_interaction,
              work_email,
              delivery_address,
            },
            index,
          ) => ({
            id: index,
            first_name,
            last_name,
            clicks,
            first_interaction,
            last_interaction,
            work_email,
            delivery_address,
          }),
        )}
        columns={columns}
        disableRowSelectionOnClick
        slots={{ toolbar: ExportToolbar }}
        showToolbar
      />
    </Box>
  );
};
